import { FunctionComponent, ReactElement } from 'react'
import styled from '@emotion/styled'
import GoogleMapReact from 'google-map-react'
import publicConfig from '@/config/public'
import { Grid, GridProps, SvgIcon } from '@/tbui'

interface MapProps extends GridProps {
  longitude: number
  latitude: number
  small?: boolean
  height?: string
  width?: string
}

const StyledMapWrapper = styled(Grid)<MapProps>`
  display: block;
  border: 1px solid ${(props) => props.theme.palette.GRAY_1};
  ${(props) => props.height && { height: props.height }};
  ${(props) => props.width && { width: props.width }};
  background-color: ${(props) => props.theme.palette.SECONDARY};
  ${(props) =>
    props.theme.mixin.fluidRange(
      {
        prop: 'height',
        fromSize: '100px',
        toSize: props.small ? '100px' : '150px',
      },
      {
        prop: 'width',
        fromSize: '115px',
        toSize: props.small ? '115px' : '175px',
      }
    )};
`

const StyledSvgIcon = styled(SvgIcon)`
  position: absolute;
  // this translate is required to center the marker in the middle of the map
  transform: translate(-50%, -100%);
`

const Marker: FunctionComponent<{
  lat: number
  lng: number
}> = (): ReactElement => <StyledSvgIcon name="map_marker" fontSize="28px" />

const Map: FunctionComponent<MapProps> = ({ ...wrapperProps }) => {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledMapWrapper {...wrapperProps} data-test="google-maps">
      <GoogleMapReact
        bootstrapURLKeys={{ key: publicConfig.googleMapsAPIKey }}
        defaultCenter={{
          lat: wrapperProps.latitude,
          lng: wrapperProps.longitude,
        }}
        defaultZoom={11}
        options={{
          fullscreenControl: false,
        }}
      >
        <Marker lat={wrapperProps.latitude} lng={wrapperProps.longitude} />
      </GoogleMapReact>
    </StyledMapWrapper>
  )
}

export default Map
